import { render, staticRenderFns } from "./PoyDetails.vue?vue&type=template&id=1c7191be&scoped=true&"
import script from "./PoyDetails.vue?vue&type=script&lang=js&"
export * from "./PoyDetails.vue?vue&type=script&lang=js&"
import style0 from "./PoyDetails.vue?vue&type=style&index=0&id=1c7191be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7191be",
  null
  
)

export default component.exports